import { Draggable } from "@hello-pangea/dnd";

import { Tab } from "../Tab";
import { TabItem } from "../types";

interface DraggableTabProps {
  tab: TabItem;
  index: number;
  currentIndex: number;
  handleTabChange?: (tabId: number) => void;
  staticTabsCount: number;
}

const DraggableTab = ({
  tab,
  index,
  currentIndex,
  handleTabChange,
  staticTabsCount,
}: DraggableTabProps) => (
  <Draggable draggableId={`tab-${tab.id}`} index={index} isDragDisabled={tab.disabled}>
    {(provided, snapshot) => (
      <div
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        className={`[data-rbd-draggable-id]:left-auto [data-rbd-draggable-id]:right-auto select-none ${
          snapshot.isDragging ? "z-50" : ""
        }`}
      >
        <Tab
          tab={tab}
          index={index}
          currentIndex={currentIndex}
          handleTabChange={handleTabChange}
          isDragging={snapshot.isDragging}
          isDynamic
          isActive={false}
          staticTabsCount={staticTabsCount}
        />
      </div>
    )}
  </Draggable>
);

export default DraggableTab;
